import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import MainLayout from "../layout/MainLayout";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";

import LandingPage from "../pages/landingPage/LandingPage";
const AdminPage = lazy(() => import("../pages/adminPage/AdminPage"));
const Page404 = lazy(() => import("../pages/page404/Page404"));
const NewsPage = lazy(() => import("../pages/newsPage/NewsPage"));
const NewsDetailPage = lazy(() =>
  import("../pages/newsDetailPage/NewsDetailPage")
);
const OrganizersPage = lazy(() =>
  import("../pages/organizersPage/OrganizersPage")
);
const OrganizerDetailPage = lazy(() =>
  import("../pages/organizerDetailPage/OrganizerDetailPage")
);
const ProjectsPage = lazy(() => import("../pages/projectsPage/ProjectsPage"));
const ProjectDetailPage = lazy(() =>
  import("../pages/projectDetailPage/ProjectDetailPage")
);
const ReportsPage = lazy(() => import("../pages/reportsPage/ReportsPage"));

export default function AppRouter() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="tips" element={<NewsPage />} />
          <Route path="tips/:id" element={<NewsDetailPage />} />
          <Route path="team" element={<OrganizersPage />} />
          <Route path="team/:name" element={<OrganizerDetailPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/:id" element={<ProjectDetailPage />} />
          <Route path="reports" element={<ReportsPage />} />
        </Route>
        <Route path="*" element={<Page404 />} />
        <Route path="adminf83922ab" element={<AdminPage />} />
      </Routes>
    </Suspense>
  );
}
